import { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { estimateService } from '../services/estimateService';
import { EstimateResponse } from '../types/estimate';

export const useEstimateDetail = (id: string | undefined) => {
  const [estimate, setEstimate] = useState<EstimateResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const fetchEstimate = async () => {
      if (!id) {
        setError('No estimate ID provided');
        setLoading(false);
        return;
      }
      
      try {
        setLoading(true);
        setError(null);
        const data = await estimateService.getEstimate(id);
        setEstimate(data);
      } catch (error: any) {
        console.error('Failed to fetch estimate:', error);
        const errorMessage = error.response?.data?.detail || 'Failed to load estimate';
        setError(errorMessage);
        enqueueSnackbar(errorMessage, { variant: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchEstimate();
  }, [id, enqueueSnackbar]);

  const refreshEstimate = async () => {
    if (!id) return;
    
    try {
      const data = await estimateService.getEstimate(id);
      setEstimate(data);
    } catch (error: any) {
      console.error('Failed to refresh estimate:', error);
      enqueueSnackbar('Failed to refresh estimate', { variant: 'error' });
    }
  };

  return {
    estimate,
    loading,
    error,
    refreshEstimate,
    setEstimate
  };
};